import { useQuery } from '@tanstack/react-query';
import { queryKeys, uuidRegEx } from '@utils/consts';
import { queryFetch } from '@services/api';
import { ApiError } from '@root/globalTypes';
import { UserRespSuccess } from './types';
import { useAppContext } from '@contexts/app';
import { usePanel } from '@hooks/usePanel';
import { parseDisplayOptions, parseDisplayOptionsSettings } from '../displayOptions/helpers';

export const useGetUser = (id: string) => {
  const { isResolvingAuth } = useAppContext();
  const { panel } = usePanel();

  const { data, error, isPending, isFetching, refetch } = useQuery<UserRespSuccess, ApiError>({
    queryKey: [...queryKeys.user, id],
    queryFn: () => queryFetch({ url: `resources/users/${id}` }),
    enabled: Boolean(!panel && !isResolvingAuth && id && uuidRegEx.test(id)),
    retry: 2,
    select: (resp) => ({
      ...resp,
      data: {
        ...resp.data,
        displayOptions: parseDisplayOptions(resp.data.displayOptions),
        displayOptionsSettings: parseDisplayOptionsSettings(resp.data.displayOptionsSettings),
      },
    }),
  });

  return {
    data,
    error,
    refetch,
    isFetching,
    isLoading: isPending && Boolean(!panel && !isResolvingAuth && id && uuidRegEx.test(id)),
  };
};
